import useMediaQuery from '@mui/material/useMediaQuery';
import useTheme from '@mui/material/styles/useTheme';

const Logo = ({ isDarkMode, width = '100px' }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <div className="w-1/3 sm:w-1/4 lg:w-1/5 flex justify-center mr-1 md:mr-0">
      <a className="no-underline" href="/">
        <img
          src={
            isDarkMode ? '/images/a369/logo-dark.svg' : '/images/a369/logo.svg'
          }
          alt="Stockup.vn - Trợ lý đầu tư chứng khoán."
          width={isSmallScreen ? '80px' : width}
        />
      </a>
    </div>
  );
};

export default Logo;
